import { createSlice } from '@reduxjs/toolkit'

/**
 * Slice reservado para estado de UI del modulo Sitios.
 *
 * Actualmente solo conserva el modo inicial de crear/editar y no define acciones.
 */
export const sitiosSlice = createSlice({
  name: 'sitios',
  initialState: { isModoCrearEditar: true },
  reducers: {
  },
})

export default sitiosSlice.reducer
